import { Trans } from "react-i18next"

import FormattedComment from "components/lib/FormattedComment"
import util from "utils/utils"

const ProjectIdeaReplied = ({ events, ownerIdea, ownerChallenge }) => {
  return (
    <Trans
      i18nKey="notifications.projectIdeaReplied"
      values={{
        name: util.getEventNames(events),
        idea: ownerIdea?.name || "Deleted",
        challenge: ownerChallenge?.name || "Deleted",
        comment: events[0]?.comment || "",
      }}
      components={{
        b: <b />,
        formattedComment: <FormattedComment noLink />,
      }}
    />
  )
}

export default ProjectIdeaReplied
